import { AIGeneratedField } from '@/redux/slices/formAIGenerationSlice'
import { nanoid } from '@reduxjs/toolkit'
import { BuiltFieldAttributes, FieldBuilderParams, GoodsItem } from './baseFieldBuilder'

const GOODS_ITEM_LAYOUTS = ['without_images']

const GOODS_FIELD_CUSTOMIZED_TYPES = ['WithoutImagesGoodsField']

export default function goodsItemsBuilder({ rawField }: FieldBuilderParams): Partial<BuiltFieldAttributes> {
  return {
    goodsItems: buildGoodsItems(rawField.goodsItems),
    customizedType:
      rawField.customizedType && GOODS_FIELD_CUSTOMIZED_TYPES.includes(rawField.customizedType)
        ? rawField.customizedType
        : null,
  }
}

function buildGoodsItems(rawGoodsItems: AIGeneratedField['goodsItems']): GoodsItem {
  if (Array.isArray(rawGoodsItems) && rawGoodsItems.length > 0) {
    return rawGoodsItems.map(goodsItem => ({
      type: 'GoodsItem',
      value: nanoid(),
      name: goodsItem.name,
      layout: GOODS_ITEM_LAYOUTS.find(layout => layout === goodsItem.layout) ?? GOODS_ITEM_LAYOUTS[0]!,
      price: goodsItem.price ?? 0,
      dimensions: goodsItem.dimensions?.map(dimension => ({
        label: dimension.label,
        value: dimension.value,
        options:
          dimension.options?.map(option => ({
            label: option.label,
            value: option.value,
          })) ?? [],
      })),
      skus:
        goodsItem.skus?.map(sku => ({
          price: sku.price ?? 0,
          specification: sku.specification?.reduce<Record<string, unknown>>(
            (spec, curr) =>
              Object.assign(spec, {
                [curr.dimensionValue]: curr.dimensionOptionValue,
              }),
            {}
          ),
        })) ?? [],
    }))
  }

  return [
    { type: 'GoodsItem', layout: GOODS_ITEM_LAYOUTS[0]!, name: '商品一', value: nanoid(), position: 0, price: 0 },
    { type: 'GoodsItem', layout: GOODS_ITEM_LAYOUTS[0]!, name: '商品二', value: nanoid(), position: 1, price: 0 },
    { type: 'GoodsItem', layout: GOODS_ITEM_LAYOUTS[0]!, name: '商品三', value: nanoid(), position: 2, price: 0 },
  ]
}
